import React from "react";

export default function DashboardStatusLine({
  counts,
  favouriteCount,
  showFavourites = false,
  L,
  F,
  lpct,
  cap,
  waitlisted,
  balanceMessage,
}) {
  return (
    <div className="space-y-2 pb-4 border-b border-black/[0.08]" data-testid="balance-tile">
      {balanceMessage && (
        <p className="font-ui font-semibold text-[15px] leading-snug text-ink" data-testid="balance-message">
          {balanceMessage}
        </p>
      )}
      <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 font-ui text-[14px] text-ink/75">
        {showFavourites && (
          <span className="tabular-nums" data-testid="favourite-count">
            <span className="font-bold text-[18px] text-plum">{favouriteCount ?? 0}</span>
            {" following"}
          </span>
        )}
        <span className="tabular-nums" data-testid="total-count">
          <span className="font-bold text-[18px] text-plum">{counts.total}</span>
          {" RSVPs"}
        </span>
        {cap > 0 && (
          <span className="tabular-nums">
            · {counts.total >= cap ? "full" : `${cap - counts.total} spots left`}
          </span>
        )}
        {waitlisted > 0 && <span className="tabular-nums">· {waitlisted} on waitlist</span>}
      </div>
      <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1 font-ui text-[13px] text-ink/70 tabular-nums">
        <span>{Math.round(L)} leaders · {Math.round(F)} followers</span>
      </div>
      <div
        className="rounded-btn h-2 bg-cream border border-black/[0.08] overflow-hidden flex max-w-md"
        role="img"
        aria-label={`${Math.round(L)} leaders, ${Math.round(F)} followers`}
      >
        <div className="bg-leaders h-full transition-all duration-500 motion-reduce:transition-none" style={{ width: `${lpct}%` }} />
        <div className="bg-followers h-full transition-all duration-500 motion-reduce:transition-none" style={{ width: `${100 - lpct}%` }} />
      </div>
    </div>
  );
}
